import { useEffect, useRef } from 'react';

function useDrawerNavigationSync({
    location,
    shouldDisableDrawer,
    isDrawerOpen,
    openDrawer,
    closeDrawer,
    user,
    registerRouteChange,
}) {
    const drawerGestureStartRef = useRef(null);
    const drawerGestureActiveRef = useRef(false);

    useEffect(() => {
        registerRouteChange();
    }, [location.key, registerRouteChange]);

    useEffect(() => {
        if (shouldDisableDrawer && isDrawerOpen) {
            closeDrawer();
        }
    }, [shouldDisableDrawer, isDrawerOpen, closeDrawer]);

    useEffect(() => {
        if (shouldDisableDrawer) {
            return;
        }
        const normalizedPath = location.pathname.toLowerCase();
        const isDashboardLikePath = normalizedPath === '/dashboard' || normalizedPath.startsWith('/dashboard/');
        if (!user && isDashboardLikePath && !isDrawerOpen) {
            openDrawer('Accedi per consultare questa sezione');
        }
    }, [location.pathname, user, isDrawerOpen, openDrawer, shouldDisableDrawer]);

    useEffect(() => {
        if (shouldDisableDrawer) {
            drawerGestureActiveRef.current = false;
            drawerGestureStartRef.current = null;
            return undefined;
        }

        const handleTouchStart = (event) => {
            if (event.touches.length !== 1) return;
            const { clientX } = event.touches[0];
            if (clientX < window.innerWidth - 24) return;
            drawerGestureActiveRef.current = true;
            drawerGestureStartRef.current = clientX;
        };

        const handleTouchMove = (event) => {
            if (!drawerGestureActiveRef.current || event.touches.length !== 1) return;
            if (isDrawerOpen) {
                drawerGestureActiveRef.current = false;
                drawerGestureStartRef.current = null;
                return;
            }
            const { clientX } = event.touches[0];
            const delta = (drawerGestureStartRef.current || clientX) - clientX;
            if (delta > 40) {
                drawerGestureActiveRef.current = false;
                drawerGestureStartRef.current = null;
                openDrawer();
            }
        };

        const handleTouchEnd = () => {
            drawerGestureActiveRef.current = false;
            drawerGestureStartRef.current = null;
        };

        window.addEventListener('touchstart', handleTouchStart, { passive: true });
        window.addEventListener('touchmove', handleTouchMove, { passive: true });
        window.addEventListener('touchend', handleTouchEnd, { passive: true });

        return () => {
            window.removeEventListener('touchstart', handleTouchStart);
            window.removeEventListener('touchmove', handleTouchMove);
            window.removeEventListener('touchend', handleTouchEnd);
        };
    }, [isDrawerOpen, openDrawer, shouldDisableDrawer]);
}

export default useDrawerNavigationSync;
